import { ComponentAPI } from '@philips-internal/oswald-ui-core';
import { SuppressHeadingMarginProperties } from './suppress-heading-margin-types.js';
class SuppressHeadingMarginAPI extends ComponentAPI {
    getApplyLeftPadding() {
        return this.state.applyLeftPadding ?? SuppressHeadingMarginProperties.applyLeftPadding.defaultValue;
    }
    setApplyLeftPadding(applyLeftPadding) {
        this.setState({ applyLeftPadding });
    }
    getApplyRightPadding() {
        return this.state.applyRightPadding ?? SuppressHeadingMarginProperties.applyRightPadding.defaultValue;
    }
    setApplyRightPadding(applyRightPadding) {
        this.setState({ applyRightPadding });
    }
}
export { SuppressHeadingMarginAPI, };
//# sourceMappingURL=suppress-heading-margin-api.js.map